<template>
  <v-snackbar v-model="snackbarStore.status" :bottom="y === 'bottom'" :color="snackbarStore.color" :left="x === 'left'"
    :multi-line="mode === 'multi-line'" :right="x === 'right'" :timeout="snackbarStore.timeout" :top="y === 'top'"
    :vertical="mode === 'vertical'">
    {{ snackbarStore.text }}
    <template v-slot:action="{ attrs }">
      <v-btn dark
      text text v-bind="attrs" @click="close">
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
  </v-card>
</template>
<script>
  export default {
    data() {
      return {
        color: '',
        mode: '',
        snackbar: true,
        text: '',
        timeout: 10000,
        x: null,
        y: 'top',
      }
    },
    computed: {
      snackbarStore() {
        return this.$store.getters.getSnackbar
      }
    },
    methods: {
      close() {
        this.$store.commit('snackbarDisabled', false)
      }
    }
  }
</script>